import { Z_INDEX_OVERLAY_HIGH } from '../../constants/z_index';
import styled from 'styled-components';
import ErrorBoundary from '../ErrorBoundary';
import FloatingAlert from './FloatingAlert';
import useAlertsList from './hooks/useAlertsList';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "AlertList__StyledDiv",
  componentId: "sc-1qrjeto-0"
})(["position:fixed;z-index:", ";left:50%;top:20px;transform:translate(-50%,0);text-align:center;"], Z_INDEX_OVERLAY_HIGH);
export const AlertList = () => {
  const {
    alerts,
    dismissAlert
  } = useAlertsList();
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "Alert List",
    children: /*#__PURE__*/_jsx(StyledDiv, {
      id: "hs-global-navigation-alerts-list",
      children: alerts.map(alert => {
        return /*#__PURE__*/_createElement(FloatingAlert, Object.assign({}, alert, {
          key: alert.id,
          onClose: dismissAlert(alert.id)
        }));
      })
    })
  });
};